import { useQuery, UseQueryResult } from 'react-query';
import api from '../../utils/api/api';
import { News } from '../../types/News';
import { API_PUBLIC_NEWS } from '../../utils/api/constants';

export const usePublicNewsBySlug = (slug: string): UseQueryResult<News, unknown> => {
  return useQuery(['publicNews', slug], async () => {
    const { data } = await api.get(`${API_PUBLIC_NEWS}/${slug}`);
    return data;
  });
};
